import React from 'react';

import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { HeaderNavigation } from '../../../header';
import { HeaderWelcome } from '../../../header/header-welcome';

import { DEFAULT_MEDIA_POINT, Routes } from '@share/constants';
import { RemoveLuxuryHomesParams, RootState } from '@share/utils';

import LuxuryHomesLogo from '@assets/images/luxury/luxury-homes-logo.svg';

import './style.scss';

interface IProps {
  fixed?: boolean;
  className?: string;
}

export const LuxuryHomesHeader: React.FC<IProps> = ({ fixed = false, className }) => {

  const history = useHistory();

  const { account} = useSelector((state: RootState) => state.loginStore);

  const handleLogoClick = () => {
    RemoveLuxuryHomesParams();
    
    history.push(`/${account?.name}${Routes.LuxuryHomes}${location.search}`);
  };

  const isMobile = document.body.offsetWidth <= DEFAULT_MEDIA_POINT;

  return (
    <header className={`luxury-homes-header ${fixed ? 'fixed-position' : ''} ${className}`}>
      <div className="luxury-homes-header__logo" style={{ cursor: 'pointer' }} onClick={handleLogoClick} >
        <img src={LuxuryHomesLogo} alt="Luxury Homes Logo" />
      </div>

      <HeaderNavigation matches={!isMobile} isShowCreditsDrawer={false} isVacationRentals={false} />

      <HeaderWelcome matches={!isMobile} isShowCredits={false} />

    </header>
  );
};
